import { useEffect, useState,useRef } from 'react';
import jwtAxios from '@projectK/services/auth/JWT';

const WaiverAuthenticate = (user) => {
  const [arr, setArr] = useState(true);
  const abortControllerRef = useRef(null);
  useEffect(() => {
    const isStudentOnly =
      user?.id &&
      user.role &&
      user.role.length === 1 &&
      user.role[0] === 'student';

    if (isStudentOnly) {
      fetchReportFields();
      return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
    }
  }, [user]);

  const fetchReportFields = async () => {
    try {
      abortControllerRef.current = new AbortController();
      const { signal } = abortControllerRef.current;
      if (user?.actualUser.length === 0) {
      const response = await jwtAxios.get(`/userwaiver/user/${user.id}`, {
       signal: signal, 
       });  
        const { data } = response;
        setArr(data);
      }
    } catch (error) {
      setArr(true);
    }
  };

  return arr;
};

export default WaiverAuthenticate;
